import { DataSourceExecutionEvent } from "@mcleod/components";
import { LayoutUrl } from "@mcleod/core";
import { AutogenLayoutBrokerageStatusEventQuickInfo } from "./autogen/AutogenLayoutBrokerageStatusEventQuickInfo";

export class BrokerageStatusEventQuickInfo extends AutogenLayoutBrokerageStatusEventQuickInfo {

    sourceEventAfterExecution(event: DataSourceExecutionEvent) {
        this.textboxId.printableLabel.link = LayoutUrl.createForUpdateMode(
            "lme/dispatch/QualifierCode",
            event.data?.get("id")
        );
    }
}
